import { render, staticRenderFns } from "./customConsent.vue?vue&type=template&id=01070abd&"
import script from "./customConsent.vue?vue&type=script&lang=js&"
export * from "./customConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports